@if ((viewControlContainers$ | async)?.length > 1) {
  <div
    fxLayout="row"
    fxLayoutAlign="space-between center"
    class="select-group-bar"
    [ngClass]="{ 'is-open': isMenuActive }">
    <div>{{ formGroupName }}</div>
    <div>
      <topo-action-menu
        icon="caret_down"
        (showHideMenu)="showHideMenu($event)"
        [alignBottom]="true"
        [submenuLabel]="false">
        @for (container of viewControlContainers$ | async; track container.uId) {
          <topo-action
            [label]="container.name"
            (actionClick)="selectViewControlContainer(container)"></topo-action>
        }
      </topo-action-menu>
    </div>
  </div>
}
